var _rect, _rect2, _circle, _g, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupportscreenimage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 92,
    viewBox: "0 0 343 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 86.5664,
    y: 41.0039,
    width: 168.571,
    height: 8.46108,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 41,
    width: 168,
    height: 8,
    fill: "#006779"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5597,
    cy: 45.5597,
    r: 45.5597,
    fill: "#006779"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_25077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.8697 28.9629H26.9033C26.1841 28.9629 25.4943 29.2486 24.9857 29.7572C24.4771 30.2658 24.1914 30.9555 24.1914 31.6748V58.7936C24.1914 59.5129 24.4771 60.2027 24.9857 60.7112C25.4943 61.2198 26.1841 61.5055 26.9033 61.5055H64.8697C65.5889 61.5055 66.2787 61.2198 66.7873 60.7112C67.2959 60.2027 67.5816 59.5129 67.5816 58.7936V31.6748C67.5816 30.9555 67.2959 30.2658 66.7873 29.7572C66.2787 29.2486 65.5889 28.9629 64.8697 28.9629ZM47.2424 50.658H33.683C33.3234 50.658 32.9785 50.5151 32.7242 50.2608C32.4699 50.0065 32.3271 49.6617 32.3271 49.302C32.3271 48.9424 32.4699 48.5975 32.7242 48.3432C32.9785 48.089 33.3234 47.9461 33.683 47.9461H47.2424C47.6021 47.9461 47.9469 48.089 48.2012 48.3432C48.4555 48.5975 48.5984 48.9424 48.5984 49.302C48.5984 49.6617 48.4555 50.0065 48.2012 50.2608C47.9469 50.5151 47.6021 50.658 47.2424 50.658ZM58.09 45.2342H33.683C33.3234 45.2342 32.9785 45.0914 32.7242 44.8371C32.4699 44.5828 32.3271 44.2379 32.3271 43.8783C32.3271 43.5186 32.4699 43.1738 32.7242 42.9195C32.9785 42.6652 33.3234 42.5223 33.683 42.5223H58.09C58.4496 42.5223 58.7945 42.6652 59.0488 42.9195C59.3031 43.1738 59.4459 43.5186 59.4459 43.8783C59.4459 44.2379 59.3031 44.5828 59.0488 44.8371C58.7945 45.0914 58.4496 45.2342 58.09 45.2342ZM58.09 39.8104H33.683C33.3234 39.8104 32.9785 39.6676 32.7242 39.4133C32.4699 39.159 32.3271 38.8141 32.3271 38.4545C32.3271 38.0949 32.4699 37.75 32.7242 37.4957C32.9785 37.2414 33.3234 37.0985 33.683 37.0985H58.09C58.4496 37.0985 58.7945 37.2414 59.0488 37.4957C59.3031 37.75 59.4459 38.0949 59.4459 38.4545C59.4459 38.8141 59.3031 39.159 59.0488 39.4133C58.7945 39.6676 58.4496 39.8104 58.09 39.8104Z",
    fill: "white"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 297.443,
    cy: 45.5597,
    r: 45.5597,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288.715 31.9722C288.861 30.5097 289.372 29.1073 290.202 27.8943C291.032 26.6813 292.154 25.6966 293.464 25.0307C294.775 24.3649 296.231 24.0394 297.701 24.0841C299.17 24.1289 300.604 24.5425 301.871 25.2869C303.138 26.0313 304.198 27.0825 304.953 28.3438C305.707 29.6051 306.132 31.036 306.189 32.5047C306.246 33.9734 305.932 35.4327 305.277 36.7483C304.634 38.0392 303.682 39.1511 302.507 39.9857",
    stroke: "white",
    strokeWidth: 2.60341,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M289.91 28.4238C291.266 29.8237 292.89 30.9366 294.685 31.6962C296.479 32.4558 298.409 32.8468 300.358 32.8457C302.274 32.8476 304.172 32.4702 305.941 31.7356",
    stroke: "white",
    strokeWidth: 2.60341,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M295.561 39.1035C295.067 39.1035 294.583 39.2503 294.171 39.5254C293.759 39.8004 293.439 40.1913 293.249 40.6487C293.06 41.1059 293.01 41.6092 293.107 42.0947C293.203 42.5803 293.442 43.0263 293.792 43.3763C294.142 43.7263 294.588 43.9648 295.073 44.0614C295.559 44.1578 296.062 44.1083 296.519 43.9189C296.977 43.7295 297.368 43.4086 297.643 42.997C297.918 42.5855 298.064 42.1014 298.064 41.6065C298.064 40.9427 297.801 40.306 297.331 39.8366C296.862 39.3672 296.225 39.1035 295.561 39.1035Z",
    stroke: "white",
    strokeWidth: 2.60341,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M285.543 34.8008V36.5996C285.543 37.9272 286.07 39.2005 287.009 40.1393C287.948 41.0781 289.221 41.6055 290.549 41.6055H292.924",
    stroke: "white",
    strokeWidth: 2.60341,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M313.709 61.6296C313.709 58.6538 312.892 55.7352 311.347 53.1919C309.809 50.6587 307.607 48.5946 304.98 47.2227",
    stroke: "white",
    strokeWidth: 2.60341,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M281.168 61.6278C281.168 58.6522 281.984 55.734 283.528 53.1905C285.065 50.6598 287.263 48.5971 289.885 47.2246",
    stroke: "white",
    strokeWidth: 2.60341,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_25077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.8139,
    height: 48.8139,
    fill: "white",
    transform: "translate(21.4805 20.8262)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportscreenimage);
export default __webpack_public_path__ + "static/media/supportscreenimage.11c10a58fc1a65515f1fd0eb6f21f4c7.svg";
export { ForwardRef as ReactComponent };